import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiActivity, FiHeadphones, FiCpu } = FiIcons;

const steps = [
  { id: 1, text: "Extracting audio signature...", icon: FiHeadphones },
  { id: 2, text: "Analyzing tempo, key & genre...", icon: FiActivity },
  { id: 3, text: "Generating Suno V5 prompts...", icon: FiCpu },
];

const LoadingState = ({ isVisible }) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    let interval;
    if (isVisible) {
      setCurrentStep(0);
      interval = setInterval(() => {
        setCurrentStep((prev) => {
          if (prev < steps.length - 1) return prev + 1;
          return prev;
        });
      }, 1500); // Change step every 1.5 seconds
    }
    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      className="max-w-md mx-auto mt-16 p-8 bg-white/80 backdrop-blur-md rounded-3xl shadow-xl border border-orange-100 text-center"
    >
      <div className="relative w-24 h-24 mx-auto mb-8">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="absolute inset-0 rounded-full border-t-4 border-r-4 border-orange-500 opacity-20"
        />
        <motion.div
          animate={{ rotate: -360 }}
          transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          className="absolute inset-2 rounded-full border-b-4 border-l-4 border-red-400 opacity-40"
        />
        <div className="absolute inset-0 flex items-center justify-center">
           <SafeIcon icon={steps[currentStep].icon} className="text-3xl text-orange-600" />
        </div>
      </div>

      <div className="space-y-4 text-left">
        {steps.map((step, index) => {
          const isActive = index === currentStep;
          const isPast = index < currentStep;
          
          return (
            <div key={step.id} className="flex items-center gap-3">
              <div className={`w-6 h-6 rounded-full flex items-center justify-center border-2 transition-colors duration-300 ${
                isPast ? 'bg-green-500 border-green-500' : 
                isActive ? 'border-orange-500' : 'border-stone-200'
              }`}>
                {isPast ? (
                  <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }}>
                    <SafeIcon icon={FiIcons.FiCheck} className="text-white text-xs" />
                  </motion.div>
                ) : isActive ? (
                  <motion.div
                    animate={{ scale: [1, 1.5, 1] }}
                    transition={{ repeat: Infinity, duration: 1 }}
                    className="w-2 h-2 bg-orange-500 rounded-full"
                  />
                ) : null}
              </div>
              <span className={`transition-colors duration-300 font-medium ${
                isPast ? 'text-stone-400' : 
                isActive ? 'text-orange-700' : 'text-stone-300'
              }`}>
                {step.text}
              </span>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default LoadingState;